import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
// Redux
import { useSelector } from "react-redux";
// Config, Static Datas and Assets
import { userTypes } from "constants/layout";
import SaIbAgreementPdf from "assets/pdf/SA_IB_Agreement-int2.pdf";
import IbAgreementPdf from "assets/pdf/IB_Agreement-int2.pdf";
import SalesAgreementPdf from "assets/pdf/Sales_Agreement-int2.pdf";
// Helpers and Hooks
import { isInvestCompany } from "helpers/Others/company_helper";
import { useGlobalHooks } from "hooks/useGlobalHooks";
import { getAppConfig } from "config/configInitializer";

const Footer = () => {
  const { t } = useGlobalHooks();
  const { company } = getAppConfig();

  const { authData } = useSelector((state: any) => state.Dashboard);

  const [isInvest, setIsInvest] = useState(false);

  useEffect(() => {
    (async () => {
      const invest = await isInvestCompany();
      setIsInvest(invest);
    })();
  }, []);

  const countryOfResidenceId = authData.countryOfResidenceId;
  const userRole = authData?.userRoleType || "Partner";

  const pdfUrl =
    userRole === userTypes.SELLER_ROLE
      ? SalesAgreementPdf
      : countryOfResidenceId == "192"
        ? SaIbAgreementPdf
        : IbAgreementPdf;

  const investLinks = [
    {
      url: "https://www.triveinvest.co.id/pdf/Privacy-Policy.pdf",
      label: t("privacypolicy"),
      external: true,
    },
    {
      url: "https://www.triveinvest.co.id/pdf/Terms_of_Business.pdf",
      label: t("termsofbusiness"),
      external: true,
    },
    {
      url: "https://www.triveinvest.co.id/tentang-kami/dokumen-legal",
      label: t("risknotification"),
      external: true,
    },
    {
      url: "https://www.triveinvest.co.id/tentang-kami/izin-kami",
      label: t("licenses"),
      external: true,
    },
  ];

  const generalLinks = [
    {
      url: "https://www.trive.com/int/about/legal-documents",
      label: t("termsandconditions"),
    },
    {
      url: pdfUrl,
      label:
        userRole === userTypes.SELLER_ROLE
          ? t("serviceagreement")
          : t("ibagreement"),
      external: true,
    },
    { url: "/contact-us", label: t("support") },
  ];

  const links = isInvest ? investLinks : generalLinks;

  return (
    <React.Fragment>
      <footer className="footer px-4">
        <Container fluid>
          <Row>
            <Col
              sm={12}
              md={6}
              xl={isInvest ? 6 : 4}
              className="d-flex justify-content-between pt-2"
            >
              {isInvest ? (
                <span className="footer-company-text">
                  @ Trive Invest {new Date().getFullYear()}
                </span>
              ) : (
                <span className="footer-company-text">
                  Trive @ {new Date().getFullYear()}
                </span>
              )}
              {links.map(({ url, label, external }) => (
                <Link
                  key={`footer-${label}`}
                  to={url}
                  target={external ? "_blank" : "_self"}
                  rel={external ? "noopener noreferrer" : undefined}
                  className="footer-link-text"
                >
                  {label}
                </Link>
              ))}
            </Col>
          </Row>
          {isInvest ? (
            <Row>
              <Col sm={12} md={6} className="d-flex justify-content-between">
                <span className="footer-company-text">{t("support")} 5/24</span>
                <a href={`tel:150 898`} className="footer-company-text">
                  {t("call")}: 150 898
                </a>
                <a
                  href={`mailto:${company.SUPPORT_EMAIL}`}
                  className="footer-company-text"
                >
                  {t("email")}: {company.SUPPORT_EMAIL}
                </a>
              </Col>
            </Row>
          ) : null}
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
